import PropTypes from 'prop-types'

import { logbookPrivateUseModePropType } from './logbook-private-use-mode-prop-type'

/**
 * @typedef {Object} logbookPrivateUseModesConfigurationPropType
 * Defines the logbook private modes available for an account
 *
 * @property {String} countryCode          - Short abbr for country.
 * @property {String} [modesAllowed]       - Array of privateUseMode
 */
const logbookPrivateUseModesConfigurationPropType = PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    modesAllowed: PropTypes.arrayOf(logbookPrivateUseModePropType)
})

export { logbookPrivateUseModesConfigurationPropType }
